export enum AuthStatesEnum {
  AUTH = 'AUTH',
  FORGOTPWD = 'FORGOTPWD',
  RESETPWD = 'RESETPWD',
  FIRSTCONNECT = 'FIRSTCONNECT',
  BIOMETRIC_AUTH = 'BIOMETRIC_AUTH' 
}
